// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Graph_graph-container__4a977 {
  position: relative;
  overflow: hidden;
}
.Graph_graph-container__4a977.Graph_simple__WU2qk {
  border: none;
}
.Graph_graph-container__4a977 .Graph_loading__adAmF {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.Graph_graph-container__4a977 .Graph_control-panel__BN4q3 {
  background-color: rgba(0, 0, 0, 0.04);
  padding: 8px 4px;
  border-radius: 6px;
  position: absolute;
  bottom: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
}
.Graph_graph-container__4a977 .Graph_control-panel__BN4q3 button {
  min-width: 0;
}
.Graph_graph-container__4a977 .Graph_control-panel__BN4q3 button svg {
  color: var(--dark-grey);
  width: 20px;
}

.Graph_information-board__\\+b0WZ {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.Graph_information-board__container__wXW31 {
  position: absolute;
  top: -1px;
  left: -1px;
  padding: 16px;
  border-radius: 16px 0 16px 0;
  background-color: var(--background-color-2);
  box-shadow: 3px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.Graph_information-board--title__Kb7\\+I {
  color: var(--accent-color);
  font-size: 13px;
  font-weight: bold;
}
.Graph_information-board__content__2YjAN {
  width: 220px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.Graph_information-board--settings__HlDDW {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.Graph_information-board--settings--item__V6uwr {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
}
.Graph_information-board--settings--item__V6uwr p {
  font-weight: bold;
  white-space: nowrap;
}
.Graph_information-board--settings--item__V6uwr select {
  width: 100%;
}
.Graph_information-board--description__CY6LJ {
  font-size: 13px;
}
.Graph_information-board--instructions__oV2vZ {
  font-size: 13px;
  padding-left: 12px;
  gap: 8px;
}
.Graph_information-board--node__LaW2J {
  width: 220px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.Graph_information-board--avatar__Q2v68 {
  aspect-ratio: 1/1;
  object-fit: cover;
}
.Graph_information-board--brief__bAdvg {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.Graph_information-board--name__67NAf {
  font-weight: bold;
  color: var(--accent-color);
  text-align: center;
}
.Graph_information-board--institution__mKgNd {
  font-size: 13px;
  font-weight: bold;
  text-align: center;
}
.Graph_information-board--position__ocBVF {
  font-size: 12px;
  color: var(--dark-grey);
  text-align: center;
}
.Graph_information-board--statistics__8Y3yz:empty {
  display: none;
}
.Graph_information-board--statistics--item__03nQO {
  color: var(--text-1);
  font-size: 13px;
}
.Graph_information-board--statistics--item__03nQO b {
  color: var(--accent-color);
}
.Graph_information-board--keywords__2naFf {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
}
.Graph_information-board--keywords--item__JC5co {
  display: flex;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: var(--light-grey);
  border: 1px solid var(--dark-grey);
  text-align: center;
  color: var(--text-1);
  font-size: 12px;
  line-height: 1.5;
}
.Graph_information-board--btn__PRNCf {
  background-color: var(--accent-color) !important;
  margin-top: auto !important;
}
.Graph_information-board--line__kCtbg {
  display: flex;
  gap: 4px;
  width: 500px;
}
.Graph_information-board--line--node__zMQ-c {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
}
.Graph_information-board--line--node--avatar__1MH9W {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid var(--explore-color);
}
.Graph_information-board--line--info__Pm-02 {
  flex: 2 1;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.Graph_information-board--line--info__wrapper__HhET0 {
  display: flex;
  align-items: center;
  gap: 8px;
  transform: translateY(-50%);
  align-self: stretch;
}
.Graph_information-board--line--info--left__Bywse, .Graph_information-board--line--info--right__gO9cc {
  height: 1px;
  background: var(--explore-color);
  flex: 1 1;
}
.Graph_information-board--line--info--center__7HhRW {
  display: flex;
  align-items: center;
}
.Graph_information-board--line--info--center__7HhRW p {
  font-size: 13px;
  color: var(--explore-color);
  margin-left: 5px !important;
  font-weight: 600;
}
.Graph_information-board--line--info--center__7HhRW svg {
  width: 16px;
  height: 16px;
}
.Graph_information-board--line--info--center__7HhRW svg path {
  stroke-width: 1.5px;
  stroke: var(--explore-color);
}

@media only screen and (max-width: 480px) {
  .Graph_information-board__content__2YjAN {
    width: 100%;
  }
  .Graph_information-board--settings--item__V6uwr {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
  .Graph_information-board--node__LaW2J {
    width: 100%;
    flex-direction: row;
  }
  .Graph_information-board--avatar__Q2v68 {
    width: 120px;
  }
  .Graph_information-board--brief__bAdvg {
    flex: 1 1;
  }
  .Graph_information-board--name__67NAf {
    text-align: left;
  }
  .Graph_information-board--institution__mKgNd {
    text-align: left;
  }
  .Graph_information-board--position__ocBVF {
    text-align: left;
  }
  .Graph_information-board--statistics__8Y3yz {
    text-align: left;
  }
  .Graph_information-board--keywords__2naFf {
    justify-content: flex-start;
  }
  .Graph_information-board--line__kCtbg {
    width: 100%;
  }
  .Graph_information-board--line--node__zMQ-c {
    gap: 8px;
  }
  .Graph_information-board--line--node--avatar__1MH9W {
    width: 60px;
    height: 60px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/Graph/Graph.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;AACF;AAEE;EACE,YAAA;AAAJ;AAOE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,UAAA;AALJ;AAQE;EACE,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AANJ;AAQI;EACE,YAAA;AANN;AAQM;EACE,uBAAA;EACA,WAAA;AANR;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AATF;AAWE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,4BAAA;EACA,2CAAA;EAEA,yHAAA;AAVJ;AAcE;EACE,0BAAA;EACA,eAAA;EACA,iBAAA;AAZJ;AAeE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAbJ;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAdJ;AAgBI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;AAdN;AAgBM;EACE,iBAAA;EACA,mBAAA;AAdR;AAiBM;EACE,WAAA;AAfR;AAoBE;EACE,eAAA;AAlBJ;AAqBE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;AAnBJ;AAsBE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AApBJ;AAuBE;EACE,iBAAA;EACA,iBAAA;AArBJ;AAwBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAtBJ;AAyBE;EACE,iBAAA;EACA,0BAAA;EACA,kBAAA;AAvBJ;AA0BE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AAxBJ;AA2BE;EACE,eAAA;EACA,uBAAA;EACA,kBAAA;AAzBJ;AA6BI;EACE,aAAA;AA3BN;AA8BI;EACE,oBAAA;EACA,eAAA;AA5BN;AA8BM;EACE,0BAAA;AA5BR;AAiCE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,uBAAA;AA/BJ;AAiCI;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,mCAAA;EACA,kCAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AA/BN;AAmCE;EACE,gDAAA;EACA,2BAAA;AAjCJ;AAoCE;EACE,aAAA;EACA,QAAA;EACA,YAAA;AAlCJ;AAoCI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAlCN;AAoCM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;AAlCR;AAsCI;EACE,SAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AApCN;AAsCM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,mBAAA;AApCR;AAuCM;EAEE,WAAA;EACA,gCAAA;EACA,SAAA;AAtCR;AAyCM;EACE,aAAA;EACA,mBAAA;AAvCR;AAyCQ;EACE,eAAA;EACA,2BAAA;EACA,2BAAA;EACA,gBAAA;AAvCV;AA0CQ;EACE,WAAA;EACA,YAAA;AAxCV;AA0CU;EACE,mBAAA;EACA,4BAAA;AAxCZ;;AAgDA;EAEI;IACE,WAAA;EA9CJ;EAkDI;IACE,mBAAA;IACA,mBAAA;IACA,QAAA;EAhDN;EAoDE;IACE,WAAA;IACA,mBAAA;EAlDJ;EAqDE;IACE,YAAA;EAnDJ;EAsDE;IACE,SAAA;EApDJ;EAuDE;IACE,gBAAA;EArDJ;EAwDE;IACE,gBAAA;EAtDJ;EAyDE;IACE,gBAAA;EAvDJ;EA0DE;IACE,gBAAA;EAxDJ;EA2DE;IACE,2BAAA;EAzDJ;EA4DE;IACE,WAAA;EA1DJ;EA4DI;IACE,QAAA;EA1DN;EA4DM;IACE,WAAA;IACA,YAAA;EA1DR;AACF","sourcesContent":[".graph-container {\n  position: relative;\n  overflow: hidden;\n  // border: 1px solid var(--light-grey);\n\n  &.simple {\n    border: none;\n  }\n\n  .graph-svg {\n    // background-color: var(--background-color-2);\n  }\n\n  .loading {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba($color: #000000, $alpha: 0.2);\n    z-index: 1;\n  }\n\n  .control-panel {\n    background-color: rgba($color: #000000, $alpha: 0.04);\n    padding: 8px 4px;\n    border-radius: 6px;\n    position: absolute;\n    bottom: 24px;\n    right: 24px;\n    display: flex;\n    flex-direction: column;\n\n    button {\n      min-width: 0;\n\n      svg {\n        color: var(--dark-grey);\n        width: 20px;\n      }\n    }\n  }\n}\n\n.information-board {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  &__container {\n    position: absolute;\n    top: -1px;\n    left: -1px;\n    padding: 16px;\n    border-radius: 16px 0 16px 0;\n    background-color: var(--background-color-2);\n    // border: 1px solid var(--light-grey);\n    box-shadow: 3px 2px 1px -1px rgba(0, 0, 0, 0.2),\n      0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n  }\n\n  &--title {\n    color: var(--accent-color);\n    font-size: 13px;\n    font-weight: bold;\n  }\n\n  &__content {\n    width: 220px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &--settings {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    &--item {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      font-size: 13px;\n\n      p {\n        font-weight: bold;\n        white-space: nowrap;\n      }\n\n      select {\n        width: 100%;\n      }\n    }\n  }\n\n  &--description {\n    font-size: 13px;\n  }\n\n  &--instructions {\n    font-size: 13px;\n    padding-left: 12px;\n    gap: 8px;\n  }\n\n  &--node {\n    width: 220px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &--avatar {\n    aspect-ratio: 1/1;\n    object-fit: cover;\n  }\n\n  &--brief {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &--name {\n    font-weight: bold;\n    color: var(--accent-color);\n    text-align: center;\n  }\n\n  &--institution {\n    font-size: 13px;\n    font-weight: bold;\n    text-align: center;\n  }\n\n  &--position {\n    font-size: 12px;\n    color: var(--dark-grey);\n    text-align: center;\n  }\n\n  &--statistics {\n    &:empty {\n      display: none;\n    }\n\n    &--item {\n      color: var(--text-1);\n      font-size: 13px;\n\n      b {\n        color: var(--accent-color);\n      }\n    }\n  }\n\n  &--keywords {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    justify-content: center;\n\n    &--item {\n      display: flex;\n      padding: 2px 8px;\n      border-radius: 4px;\n      background-color: var(--light-grey);\n      border: 1px solid var(--dark-grey);\n      text-align: center;\n      color: var(--text-1);\n      font-size: 12px;\n      line-height: 1.5;\n    }\n  }\n\n  &--btn {\n    background-color: var(--accent-color) !important;\n    margin-top: auto !important;\n  }\n\n  &--line {\n    display: flex;\n    gap: 4px;\n    width: 500px;\n\n    &--node {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      text-align: center;\n      gap: 16px;\n\n      &--avatar {\n        width: 80px;\n        height: 80px;\n        object-fit: cover;\n        border-radius: 50%;\n        border: 1px solid var(--explore-color);\n      }\n    }\n\n    &--info {\n      flex: 2;\n      padding-top: 40px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 8px;\n\n      &__wrapper {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        transform: translateY(-50%);\n        align-self: stretch;\n      }\n\n      &--left,\n      &--right {\n        height: 1px;\n        background: var(--explore-color);\n        flex: 1;\n      }\n\n      &--center {\n        display: flex;\n        align-items: center;\n\n        p {\n          font-size: 13px;\n          color: var(--explore-color);\n          margin-left: 5px !important;\n          font-weight: 600;\n        }\n\n        svg {\n          width: 16px;\n          height: 16px;\n\n          path {\n            stroke-width: 1.5px;\n            stroke: var(--explore-color);\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .information-board {\n    &__content {\n      width: 100%;\n    }\n\n    &--settings {\n      &--item {\n        flex-direction: row;\n        align-items: center;\n        gap: 8px;\n      }\n    }\n\n    &--node {\n      width: 100%;\n      flex-direction: row;\n    }\n\n    &--avatar {\n      width: 120px;\n    }\n\n    &--brief {\n      flex: 1;\n    }\n\n    &--name {\n      text-align: left;\n    }\n\n    &--institution {\n      text-align: left;\n    }\n\n    &--position {\n      text-align: left;\n    }\n\n    &--statistics {\n      text-align: left;\n    }\n\n    &--keywords {\n      justify-content: flex-start;\n    }\n\n    &--line {\n      width: 100%;\n\n      &--node {\n        gap: 8px;\n\n        &--avatar {\n          width: 60px;\n          height: 60px;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"graph-container": `Graph_graph-container__4a977`,
	"simple": `Graph_simple__WU2qk`,
	"loading": `Graph_loading__adAmF`,
	"control-panel": `Graph_control-panel__BN4q3`,
	"information-board": `Graph_information-board__+b0WZ`,
	"information-board__container": `Graph_information-board__container__wXW31`,
	"information-board--title": `Graph_information-board--title__Kb7+I`,
	"information-board__content": `Graph_information-board__content__2YjAN`,
	"information-board--settings": `Graph_information-board--settings__HlDDW`,
	"information-board--settings--item": `Graph_information-board--settings--item__V6uwr`,
	"information-board--description": `Graph_information-board--description__CY6LJ`,
	"information-board--instructions": `Graph_information-board--instructions__oV2vZ`,
	"information-board--node": `Graph_information-board--node__LaW2J`,
	"information-board--avatar": `Graph_information-board--avatar__Q2v68`,
	"information-board--brief": `Graph_information-board--brief__bAdvg`,
	"information-board--name": `Graph_information-board--name__67NAf`,
	"information-board--institution": `Graph_information-board--institution__mKgNd`,
	"information-board--position": `Graph_information-board--position__ocBVF`,
	"information-board--statistics": `Graph_information-board--statistics__8Y3yz`,
	"information-board--statistics--item": `Graph_information-board--statistics--item__03nQO`,
	"information-board--keywords": `Graph_information-board--keywords__2naFf`,
	"information-board--keywords--item": `Graph_information-board--keywords--item__JC5co`,
	"information-board--btn": `Graph_information-board--btn__PRNCf`,
	"information-board--line": `Graph_information-board--line__kCtbg`,
	"information-board--line--node": `Graph_information-board--line--node__zMQ-c`,
	"information-board--line--node--avatar": `Graph_information-board--line--node--avatar__1MH9W`,
	"information-board--line--info": `Graph_information-board--line--info__Pm-02`,
	"information-board--line--info__wrapper": `Graph_information-board--line--info__wrapper__HhET0`,
	"information-board--line--info--left": `Graph_information-board--line--info--left__Bywse`,
	"information-board--line--info--right": `Graph_information-board--line--info--right__gO9cc`,
	"information-board--line--info--center": `Graph_information-board--line--info--center__7HhRW`
};
export default ___CSS_LOADER_EXPORT___;
